export enum EnrollPatientCaseSource {
    patientportal = 'patientportal',
    providerportal = 'providerportal',
}
